<template>
  <BContainer
    v-if="currentUser"
    fluid
    class="px-0"
  >
    <Task
      class="my-3"
      :activity="{
        activity_name: taskInformation.activity_name,
        crop_name: taskInformation.crop_name,
        total_buyers: taskInformation.customers_bought_count
      }"
      :current-progress="{
        event: taskInformation.events_count,
        customer: taskInformation.customers_attended_count,
        hectare: taskInformation.total_actual_hectares,
        cost: taskInformation.total_actual_costs,
        sales: taskInformation.total_actual_sales
      }"
      :total-progress="{
        event: taskInformation.event_plan,
        customer: taskInformation.total_customer_plan,
        hectare: taskInformation.total_hectare_plan,
        cost: taskInformation.total_budget_plan,
        sales: taskInformation.total_sales_plan
      }"
      :loading="state.busy"
    >
      <template #footer-loader>
        <div class="d-flex justify-content-start gap-2 mt-3">
          <BSkeleton
            width="62px"
            height="20px"
          />
        </div>
      </template>
      <template #footer>
        <div class="d-flex justify-content-start gap-2 mt-3">
          <BBadge variant="dark-light">
            {{ monthShortFormatter(taskInformation.schedule) }}
          </BBadge>
        </div>
      </template>
    </Task>

    <Events
      v-if="taskInformation.id"
      :task="taskInformation"
    />
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import Task from '@/views/asm/officers/task-events/components/Task.vue'
import Events from '@/views/asm/officers/task-events/Events.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MxImageUrl from '@/mixins/image-url'
import MCustomers from '@/mixins/accounts/customers'

import { SASMFsoTask } from '@/services/asm'

export default {
  name: 'ASMOfficerTaskEventsBase',

  components: {
    Events,
    Task
  },

  mixins: [
    MCustomers,
    MxMisc,
    MxFormatter,
    MxImageUrl
  ],

  middleware: [
    'auth',
    'asm'
  ],

  metaInfo: () => ({
    title: 'Officer Task Events'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        fetching: false
      },
      taskInformation: {
        id: '',
        activity_id: '',
        activity_name: '',
        assignee_id: '',
        crop_id: '',
        crop_name: '',
        schedule: '',
        event_plan: 0,
        events_count: 0,
        active: 1
      },
      gridLogs: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: 'sm',
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10
      }
    }
  },

  computed: mapGetters({
    currentUser: 'auth/user'
  }),

  mounted () {
    if (this.currentUser) {
      this.getTask()
    }
  },

  methods: {

    async getTask () {
      this.state.busy = true
      return SASMFsoTask.show(this.$route.params.task).then(
        async ({ data: { task } }) => {
          if (!task) {
            return this.swalInvalid(
              '<h6>Officer task seems to be incorrect or incomplete, please check and try again.</h6>',
              'Task Not Found'
            ).then(
              () => {
                this.$router.push({
                  name: 'asm.tracking.officer-tasks',
                  params: {
                    officer: this.officer.id
                  }
                })
              }
            )
          }

          this.taskInformation = Object.assign(this.taskInformation, {
            id: task.id,
            activity_id: task.activity_id,
            activity_name: task.activity?.activity_name || '',
            assignee_id: task.assignee_id,
            events_count: task?.events_count || 0,
            event_plan: task?.event_plan || 0,
            schedule: task.schedule
          })
        }
      ).finally(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
